import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { bookingfeelist_returndata } from 'src/types/bookingfeelist_returndata';

@Component({
  selector: 'app-bookingfeelist',
  templateUrl: './bookingfeelist.component.html',
  styleUrls: ['./bookingfeelist.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BookingfeelistComponent implements OnInit {
  ListBookingFees: any[] = [];
  httpResponse: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  isDisabled: boolean = true;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
  CurrencyMarker: string = (() => {
    const code = localStorage.getItem("Currency") ?? "GBP";
    if (code === "USD") return "$";
    if (code === "EUR") return "€";
    return "£";
  })();

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globalService: GlobalService
  ) {
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse = (response as users_returndata);
      if (this.httpResponse.succeeded) {
        let user = this.httpResponse.data;
        if (getAccess("BOOKINGFEES", user)) {
          this.AccessAllowed = true;
        }
        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting User, error:' + error.messages[0] });
    });
  }

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);
    this.loadgrid(false);
  }

  toggleDisabled() {
    this.loadgrid(!this.isDisabled);
  }

  loadgrid(showdisabled: boolean) {
    this.http.get(bmxurl + "BookingFeeList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        this.ListBookingFees = (response as bookingfeelist_returndata).data ?? [];
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error getting Booking Fees: ' + this.httpResponse.messages[0] });
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error getting Booking Fees: ' + error.messages });
    });
  }

  editData(bfid: string) {
    this.router.navigateByUrl("/bookingfeeedit/" + bfid);
  }

  addNew() {
    this.router.navigateByUrl("/bookingfeeedit/0");
  }

  disableData(bfid: string) {
    if (confirm("Are you sure you want to disable this Booking Fee?")) {
      this.http.delete(bmxurl + "BookingFee/" + this.VenueID + "/" + bfid).subscribe(response => {
        this.httpResponse = response;
        if (this.httpResponse.succeeded) {
          this.messageService.add({ severity: 'success', summary: 'Disabled', detail: 'Booking Fee successfully disabled' });
          this.loadgrid(this.isDisabled);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Not Disabled', detail: 'Error disabling Booking Fee: ' + this.httpResponse.messages[0] });
        }
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Not Disabled', detail: 'An error occurred disabling this Booking Fee' });
      });
    }
  }

  feeDisplay(type: string, fee: number): string {
    if (type === 'FIXED') return this.CurrencyMarker + fee.toFixed(2) + ' fixed';
    if (type === 'PERPERSON') return this.CurrencyMarker + fee.toFixed(2) + ' per person';
    if (type === 'PERCENTAGE') return fee + '% percentage';
    return '';
  }
}
